module.exports = __webpack_public_path__ + "static/media/menu.c159867d.svg";